// Module
var code = " <nav mat-tab-nav-bar=\"\" class=\"nav-tab-bar\" [disablePagination]=\"true\"> <a *ngFor=\"let link of links\" data-automation-id=\"tab:{{link.name}}\" matTabLink=\"\" [active]=\"link === activeLink\" class=\"nav-tab\" [class.is-active]=\"link === activeLink\" (click)=\"onClick(link)\"> <span [ghNavLinkContent]=\"link\"></span> </a> </nav> ";
// Exports
module.exports = code;